var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuote = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M3 6.5A1.5 1.5 0 0 1 4.5 5h2v3.5c0 1.933-1.067 3-3 3m6.5-5A1.5 1.5 0 0 1 11.5 5h2v3.5c0 1.933-1.067 3-3 3"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuote);
export default ForwardRef;